import { EntityWithId } from '@procsea/common/utils'

import { GenerateQueriesArgs, generateQueries } from 'src/queries/queryGenerator'

export const PASSWORD_UPDATE_ENDPOINT = 'password_update'
export const PASSWORD_UPDATE_QUERY_KEY = 'passwordUpdate'

const generateQueriesConfig: GenerateQueriesArgs<EntityWithId> = {
  endpoint: PASSWORD_UPDATE_ENDPOINT,
  queryKey: PASSWORD_UPDATE_QUERY_KEY,
}

export const { usePostEntity: usePasswordUpdate } = generateQueries(generateQueriesConfig)
